import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import {useEffect, useState} from 'react'
import useAxiosPrivate from '../../../../app/libs/useAxiosPrivate'
import {useSocket} from '../../../../app/contexts/SocketContext'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

interface ActiveJobState {
  id: string | number
  percent: number
  message: string
  status: 'active' | 'waiting'
}

const Navbar = () => {
  const {config} = useLayout()
  const axiosPrivate = useAxiosPrivate()
  const {socket} = useSocket()
  const [activeJob, setActiveJob] = useState<ActiveJobState | null>(null)

  useEffect(() => {
    let isMounted = true

    const checkJobs = async () => {
      try {
        const res = await axiosPrivate.get('/master-data/import-tariff-jobs')
        if (!isMounted) return

        const jobs = res.data?.data || []
        const runningJob = jobs.find((j: any) => j.status === 'active' || j.status === 'waiting')

        if (runningJob) {
          if (runningJob.status === 'active') {
            const progress = runningJob.progress
            const percent =
              typeof progress === 'object' && progress !== null
                ? progress.percent || 0
                : Number(progress) || 0
            const message =
              typeof progress === 'object' && progress !== null
                ? progress.message || ''
                : ''
            setActiveJob({
              id: runningJob.id,
              percent,
              message,
              status: 'active',
            })
          } else {
            setActiveJob({
              id: runningJob.id,
              percent: 0,
              message: 'Pending...',
              status: 'waiting',
            })
          }
        } else {
          setActiveJob(null)
        }
      } catch (err) {
        if (isMounted) {
          setActiveJob(null)
        }
      }
    }

    checkJobs()

    if (socket) {
      socket.emit('join-room', 'jobs')

      const handleJobUpdated = (data: any) => {
        if (!isMounted) return
        setActiveJob(prev => {
          if (prev && prev.id === data.id) {
            if (data.status === 'completed' || data.status === 'failed') {
              checkJobs()
              return null
            }
            const progress = data.progress
            const percent =
              typeof progress === 'object' && progress !== null
                ? progress.percent || 0
                : Number(progress) || 0
            const message =
              typeof progress === 'object' && progress !== null
                ? progress.message || ''
                : ''
            return {
              ...prev,
              percent,
              message: message || prev.message,
              status: data.status || prev.status,
            }
          } else if (!prev && (data.status === 'active' || data.status === 'waiting')) {
            checkJobs()
          }
          return prev
        })
      }

      socket.on('job-updated', handleJobUpdated)

      return () => {
        isMounted = false
        socket.emit('leave-room', 'jobs')
        socket.off('job-updated', handleJobUpdated)
      }
    }

    return () => {
      isMounted = false
    }
  }, [socket, axiosPrivate])

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTIcon iconName='element-plus' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div> */}

      <div className={clsx('app-navbar-item d-flex align-items-center', itemClass)}>
        <Link
          to='/file-upload-queue'
          className={clsx(btnClass, 'position-relative')}
          title='File Upload Queue'
        >
          <KTIcon iconName='cloud-add' className={btnIconClass} />
          {activeJob && (
            <span
              className={clsx(
                'bullet bullet-dot h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink',
                activeJob.status === 'waiting' ? 'bg-warning' : 'bg-primary'
              )}
            />
          )}
        </Link>
        {activeJob && (
          <div
            className='d-flex align-items-center ms-2 bg-light px-2 py-1 rounded'
            style={{fontSize: '11px', border: '1px solid #eff2f5', whiteSpace: 'nowrap'}}
          >
            <span
              className={clsx(
                'spinner-border spinner-border-sm me-2',
                activeJob.status === 'waiting' ? 'text-warning' : 'text-primary'
              )}
              style={{width: '12px', height: '12px'}}
            />
            <span className='fw-bold text-gray-700'>
              {activeJob.status === 'waiting' ? 'Pending' : `${activeJob.percent}%`}
            </span>
            {activeJob.message && (
              <span
                className='d-none d-xl-inline ms-2 text-muted text-truncate fw-normal'
                style={{maxWidth: '100px'}}
              >
                {activeJob.message}
              </span>
            )}
          </div>
        )}
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='' />
        </div>
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export {Navbar}
